// src/components/CalculateMoney/views/WorkSessionListForDay.jsx
import React, { useState } from 'react';
import { List, Box, Typography, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useTranslation } from 'react-i18next';
import UpdateWorkSessionModal from '../UpdateWorkSessionModal';

import {
  StyledListItem,
  StyledListItemText,
  StyledTypography,
} from '../../../styles/OwnerStyle/StaffComPonent/StaffListStyles';

const WorkSessionListForDay = ({
  workSessions,
  businessServices = [],
  businessId,
  onShowSuccess,
  categories,
  services = [],
  editable = true,
}) => {
  const { t } = useTranslation('overview');
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSession, setSelectedSession] = useState(null);

  if (!Array.isArray(workSessions) || workSessions.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', color: '#aaa', margin: '24px 0 32px 0' }}>
        {t('list.noFinishedSessions')}
      </Box>
    );
    }

  const businessServiceLookup = {};
  businessServices.forEach(s => {
    businessServiceLookup[s.serviceId] = s;
  });

  return (
    <>
      <List dense>
        {workSessions.map((ws) => (
          <StyledListItem
            key={ws.workSessionId}
            secondaryAction={
              editable && (
                <IconButton
                  edge="end"
                  aria-label={t('list.edit')}
                  onClick={() => {
                    setSelectedSession(ws);
                    setModalOpen(true);
                  }}
                >
                  <EditIcon />
                </IconButton>
              )
            }
          >
            <StyledListItemText
              primary={
                <StyledTypography variant="body1" sx={{ fontSize: '1.3em', fontWeight: 500 }}>
                  {ws.customerName || t('list.sessionNumber', { id: ws.workSessionId })}
                </StyledTypography>
              }
              secondary={
                <>
                  {/* Date/Time */}
                  {ws.sessionStart && (
                    <>
                      <span style={{ color: '#1e88e5' }}>
                        {new Date(ws.sessionStart).toLocaleString('de-DE', {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </span>
                      <br />
                    </>
                  )}
                  {/* Services */}
                  {ws.workSessionServices?.$values && ws.workSessionServices.$values.length > 0 && (
                    <Box sx={{ mt: 1, mb: 1, pl: 2.0 }}>
                      <b>{t('list.services')}</b>
                      <ul style={{ margin: '6px 0 0 0', padding: '0 0 0 25px' }}>
                        {ws.workSessionServices.$values.map((svc, idx) => {
                          const serviceObj = businessServiceLookup[svc.serviceId];
                          const serviceName = serviceObj?.name || t('list.unknown');
                          return (
                            <li key={svc.workSessionServiceId || idx}>
                              <Typography
                                component="span"
                                sx={{
                                  fontSize: '0.97em',
                                  color: '#1976d2',
                                  fontWeight: 500,
                                  display: 'inline'
                                }}
                              >
                                {serviceName}
                                {svc.quantity > 1 ? ` × ${svc.quantity}` : ''}
                              </Typography>
                            </li>
                          );
                        })}
                      </ul>
                    </Box>
                  )}

                  {ws.personalDesignPrice > 0 && (
                    <Typography
                      sx={{
                        fontSize: '0.97em',
                        color: '#ff9800',
                        fontWeight: 500,
                        ml: 2.0,
                        mb: 0.5,
                        display: 'block'
                      }}
                    >
                      {t('list.personalDesign')} {ws.personalDesignPrice}€
                    </Typography>
                  )}

                  {ws.totalPrice !== null && ws.totalPrice !== undefined && (
                    <span>
                      <b>{t('list.total')}</b> {ws.totalPrice}€
                    </span>
                  )}

                  {ws.note && (
                    <>
                      <br />
                      <span style={{ color: '#0288d1' }}>
                        <b>{t('list.note')}</b> {ws.note}
                      </span>
                    </>
                  )}
                </>
              }
            />
          </StyledListItem>
        ))}
      </List>

      {editable && (
        <UpdateWorkSessionModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          workSession={selectedSession}
          businessId={businessId}
          services={businessServices}
          categories={categories || []}
          onShowSuccess={onShowSuccess}
        />
      )}
    </>
  );
};

export default WorkSessionListForDay;
